import { get } from '@/services/Axios';
import debounce from 'lodash.debounce';
import errorHandler from '@/mixins/errorHandler';

export default {
  mixins: [errorHandler],
  data() {
    return {
      positionOptions: [],
      loadPositionOptions: false,
      formPositionOptionsName: '',
      searchPositionsOptions: ''
    };
  },
  watch: {
    searchPositionsOptions(val) {
      if (
        this[this.formPositionOptionsName] &&
        (!this[this.formPositionOptionsName].position ||
          val !== this[this.formPositionOptionsName].position)
      ) {
        this.getPositionOptions({ keyword: val });
      }
    }
  },
  methods: {
    getPositionOptions: debounce(async function(...param) {
      this.loadPositionOptions = true;
      const parameter = param[0] || {};
      const params = {
        limit: 99,
        sort: 'account_position',
        dir: 'ASC',
        filter: [
          {
            type: 'string',
            field: 'account_position',
            value: parameter.keyword || '',
            comparison: '<>'
          }
        ]
      };
      if (parameter.filters) {
        this.params.filter.push(...parameter.filters);
      }
      try {
        const {
          data: { results }
        } = await get('/position/list-option', { params });
        this.positionOptions = results;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadPositionOptions = false;
      }
    }, 500)
  }
};
